module.exports = __webpack_public_path__ + "img/loading.21fc5750.svg";